var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInterlayLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1112.2 249.97",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.59,250H96a5.53,5.53,0,0,1-2.88-.82L15.9,201.5a5.49,5.49,0,0,1,2.88-10.16H232.4a5.56,5.56,0,0,1,2.89.82l77.18,47.65A5.49,5.49,0,0,1,309.59,250ZM97.52,239H290.25l-59.4-36.67H38.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,58.63H82.67a5.5,5.5,0,0,1-2.88-.82L2.6,10.16A5.49,5.49,0,0,1,5.49,0H219.11A5.5,5.5,0,0,1,222,.82l77.18,47.65a5.49,5.49,0,0,1-2.88,10.16Zm-212.06-11H277L217.55,11H24.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,101.16a33.4,33.4,0,0,0-23.53-9.62h-.35a33.64,33.64,0,0,0,.33,67.28h.34A33.64,33.64,0,0,0,187,101.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.15,89.07h19.91V169H405.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.06,89.07h28.65L519,142.73h.12l-.6-53.66h18.69V169H513.7L477.4,107h-.12l.48,61.92h-18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.08,104.73h-22.7V89.07h65.19v15.66H610V169H590.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.7,89.07h56.57v15.66H682.61v18H711v12.14H682.61v18.45h37.76V169H662.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.1,89.07h37.27c21.13,0,32.54,8.74,32.54,23.79,0,10.2-4.37,16.64-11.9,18.82v.24c7.89,1.82,11.41,8.14,11.41,17.12V169H800.51v-19.3c0-7.28-2.67-10.44-10.2-10.44H771V169H751.1Zm38.12,38.12c8.38,0,12.63-3.76,12.63-11.17,0-7-4.37-11.29-13.6-11.29H771v22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.7,89.07h19.91v64.22H910V169H853.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.66,152.68H962.74L957.27,169h-20.4l30.85-79.88h24.76L1023.31,169h-23.18Zm-4.12-12.38-11.78-35h-.24l-11.66,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.73,138.36l-31.44-49.29h25.61l17.48,31.56h.36L1090,89.07h22.21l-31.56,49.29V169h-19.91Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlayLogoWithText);
export default __webpack_public_path__ + "static/media/interlay-logo-with-text.4887dd44.svg";
export { ForwardRef as ReactComponent };